import CMS, { init } from 'netlify-cms-app';
import ArticlePagePreview from './preview/article-page-preview';
import EventoPreview from './preview/evento-preview';
import StrumentoPreview from './preview/strumento-preview';
import DisturboPreview from './preview/disturbo-preview';
import ExperiencePreview from './preview/experience-preview';
import TextRowPreview from './preview/text-row-preview';
import ChiSonoPreview from './preview/chi-sono-preview';
import MetodoPagePreview from './preview/il-mio-metodo-di-lavoro-preview';
import DipendenzePreview from './preview/dipendenze-preview';
import ZoomDipendenzePreview from './preview/zoom-dipendenze-preview';
import CurriculumPreview from './preview/curriculum-preview';
import PublicationPreview from './preview/publication-preview';
import EventiPreview from './preview/eventi-pubblicazioni-preview';
import AmbitiInterventoPagePreview from './preview/ambiti-intervento-preview';
import '../css/main.scss';

CMS.registerPreviewTemplate('text-row-2', TextRowPreview);
CMS.registerPreviewTemplate('chi-sono-page', ChiSonoPreview);
CMS.registerPreviewTemplate('il-mio-metodo-di-lavoro-page', MetodoPagePreview);
CMS.registerPreviewTemplate('strumento', StrumentoPreview);
CMS.registerPreviewTemplate('ambiti-intervento-page', AmbitiInterventoPagePreview);
CMS.registerPreviewTemplate('disturbo', DisturboPreview);
CMS.registerPreviewTemplate('dipendenze', DipendenzePreview);
CMS.registerPreviewTemplate('dipendenze-page', ZoomDipendenzePreview);
CMS.registerPreviewTemplate('experience', ExperiencePreview);
CMS.registerPreviewTemplate('curriculum-page', CurriculumPreview);
CMS.registerPreviewTemplate('event', EventoPreview);
CMS.registerPreviewTemplate('publication', PublicationPreview);
CMS.registerPreviewTemplate('eventi-pubblicazioni-page', EventiPreview);
CMS.registerPreviewTemplate('pageArticles', ArticlePagePreview);

const NETLIFY_AUTH = process.env.GATSBY_NETLIFY_AUTH;

// Start NetlifyCMS
init(
  NETLIFY_AUTH === 'true'
    ? undefined
    : {
        config: {
          backend: {
            base_url: `https://progetto-facilissimo.herokuapp.com`,
            auth_endpoint: `/oauth/auth`
          }
        }
      }
);
